import React from "react";
import {Button, Card} from "react-bootstrap";

import './CharElm.css';
import MaxiIcon from "../../Maxiicon/MaxiIcon";

const CharElm = ({char, voiceDisabled, synthVoice, voiceRate = 0.5}) => {

    const onPlayClick = () => {
        // play the sound of the character
        const synth = window.speechSynthesis;
        const utterThis = new SpeechSynthesisUtterance(char);
        utterThis.lang = 'zh-CN';
        utterThis.volume = 2;
        utterThis.rate = voiceRate;
        utterThis.pitch = 1;
        utterThis.voice = synthVoice;
        synth.speak(utterThis);
    }

    return (
        <Card className={'char-card'}>
            <Card.Body>
                <Card.Title className={'char-elm'}>{char}</Card.Title>
                <Button size={"sm"} variant={"danger"} onClick={onPlayClick} disabled={voiceDisabled}>
                    <MaxiIcon iconName={'faCirclePlay'} />
                </Button>
            </Card.Body>
        </Card>
    );
}

export default CharElm;